import { render } from "./App.vue?vue&type=template&id=56454d47"
const script = {}

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__